/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { lazy, useEffect } from 'react';
import { Row, Col } from 'antd';
import Zoom from 'react-reveal/Zoom';
import { withTranslation } from 'react-i18next';
import Image from 'react-bootstrap/Image';
import useForm from './useForm';
import validate from './validationRules';

import * as S from './styles';

const Block = lazy(() => import('../Block'));
const Input = lazy(() => import('../common/Input'));
const Button = lazy(() => import('../common/Button'));
const TextArea = lazy(() => import('../common/TextArea'));
const Checkbox = lazy(() => import('../common/Checkbox'));
const Radio = lazy(() => import('../common/Radio'));

const Contact = ({
  title,
  content,
  id,
  t,
  url,
  subject,
  appId,
  action,
  color,
  secondaryColor,
  onFocusColor,
  handleChange,
  values,
  errors,
  handleSubmit,
  shouldSubmit,
  spinner,
  onGenderSelect,
  illustation,
  onSkipClick,
}) => {
  useEffect(() => {
    if (shouldSubmit) {
      console.log(`on shouldSubmut`);
      document.getElementById('contactform').reset();
    }
  }, [shouldSubmit]);

  const ValidationType = ({ type }) => {
    const ErrorMessage = errors[type];
    return errors[type] ? (
      <Zoom cascade>
        <S.Span>{ErrorMessage}</S.Span>
      </Zoom>
    ) : (
      <S.Span />
    );
  };

  const _getContactForm = () => {
    console.log(`values _getContactForm:`, values);
    return (
      <Col lg={12} md={12} sm={24}>
        <S.FormGroup
          autoComplete='off'
          id='contactform'
          onSubmit={handleSubmit}
        >
          <Col span={24}>
            <Input
              type='text'
              name='name'
              id='Name*'
              placeholder='Enter your Name'
              value={values.name || ''}
              onChange={handleChange}
            />
            <ValidationType type='name' />
          </Col>
          <Col span={24}>
            <Input
              type='email'
              name='email'
              id='Email*'
              placeholder='Enter your email'
              value={values.name || ''}
              onChange={handleChange}
            />
            <ValidationType type='email' />
          </Col>
          <Col span={24}>
            <Input
              type='number'
              name='phone'
              id='Mobile Number'
              placeholder='Enter your Mobile Number'
              value={values.phone || ''}
              onChange={handleChange}
            />
          </Col>
          <Col span={24}>
            <Checkbox
              type='checkbox'
              name='disclaimer'
              id='Agree to disclaimer'
              placeholder='Agree to disclaimer'
              value={values.disclaimer || ''}
              onChange={handleChange}
            />
            <ValidationType type='disclaimer' />
          </Col>

          <S.ButtonContainer>
            <Button
              name='submit'
              type='submit'
              color={color}
              secondaryColor={secondaryColor}
              onFocusColor={onFocusColor}
              onLoading={spinner}
            >
              {spinner === true ? t('Verifying..') : t('Submit & Verify')}
            </Button>
          </S.ButtonContainer>
        </S.FormGroup>
      </Col>
    );
  };

  const _renderIllustation = () => {
    console.log(`illustation -> `, illustation);
    return (
      <S.ImageContainer>
        <Image src={illustation} width={'80%'} height={'50%'} />
      </S.ImageContainer>
    );
  };

  return (
    <S.ContactContainer id={id}>
      <S.Contact>
        <Row type='flex' justify='space-between' align='middle'>
          {_renderIllustation()}
          <Col lg={24} md={11} sm={24}>
            <Block padding={true} title={title} content={content} />
          </Col>
          {_getContactForm()}
          <S.ButtonContainer>
            <Button
              name='submitSkip'
              type='submit'
              color={color}
              secondaryColor={secondaryColor}
              onFocusColor={onFocusColor}
              onLoading={spinner}
              onClick={onSkipClick}
            >
              {spinner === true ? t('Verifying..') : t('Skip & Verify')}
            </Button>
          </S.ButtonContainer>
          <S.Text>(Click "Skip" to verify without entering info)</S.Text>
        </Row>
      </S.Contact>
    </S.ContactContainer>
  );
};

export default withTranslation()(Contact);
